module.exports = __webpack_public_path__ + "img/regardbtn.c2d710d0.png";